const wpMenu = () => {
  const navWrap = document.querySelector('nav.nav-primary'),
        mobileMenuToggle = document.querySelector('#menu-toggle');

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function () {
      if (this.classList.contains('is-active')) {
        this.classList.remove('is-active');
        document.querySelector('body').classList.remove('menu-open');
        navWrap.style.opacity = '0';
        setTimeout(function () {
          navWrap.style.display = 'none';
        }, 750);
      } else {
        navWrap.style.display = 'block';
        this.classList.add('is-active');
        document.querySelector('body').classList.add('menu-open');
        setTimeout(function () {
          navWrap.style.opacity = '1';
        }, 10);
      }
    });
  }
}

export default wpMenu;